module dg.objects {

    interface IDgMultiPartPropertyValueExtensionScope extends ng.IScope {
        propMeta: dg.restfulApi.DomainObjectPropertyMetadata;
        readOnlyPart;
    }

    function multiPartPropertyValueExtension($compile: ng.ICompileService): ng.IDirective {
        return {
            restrict: 'A',
            require: ['ngModel', '^objectEditor'],
            compile: (templateElement: ng.IAugmentedJQuery, templateAttributes: ng.IAttributes, transclude: ng.ITranscludeFunction) => {
                return (scope: IDgMultiPartPropertyValueExtensionScope, instanceElement: ng.IAugmentedJQuery,
                    instanceAttributes: ng.IAttributes, ctrls: ng.IController[], transclude: ng.ITranscludeFunction) => {

                    let ngModelCtrl = <ng.INgModelController>ctrls[0];

                    let multipartExt = scope.propMeta.extensions.multiPartPropertyValue;
                    if (!!multipartExt.options) {
                        scope.readOnlyPart = multipartExt.delimiter + multipartExt.options.join(', ');
                    }
                    ngModelCtrl.$parsers.push((viewValue) => {
                        let parsedValue = viewValue;
                        if (!ngModelCtrl.$isEmpty(parsedValue) && (!!multipartExt.options && multipartExt.options.length > 0)) {
                            parsedValue = viewValue + scope.readOnlyPart;
                        }
                        return parsedValue;
                    });
                    ngModelCtrl.$formatters.push((modelValue) => {
                        var formatedValue = modelValue;
                        if (angular.isDefined(modelValue) && modelValue.indexOf(multipartExt.delimiter) > -1) {
                            if (angular.isDefined(multipartExt.options)) {
                                scope.readOnlyPart = multipartExt.delimiter + modelValue.substr(modelValue.lastIndexOf(multipartExt.delimiter) + 1);
                                multipartExt.options = [scope.readOnlyPart];
                            }

                            formatedValue = modelValue.substr(0, modelValue.lastIndexOf(multipartExt.delimiter));
                        }
                        return formatedValue;
                    });

                    instanceElement.wrap('<div class="input-group"></div>');
                    var compiledElement = $compile(angular.element('<span class="input-group-addon" ng-bind="readOnlyPart"></span>'))(scope);
                    instanceElement.parent().append(compiledElement);
                }
            }
        };
    }

    angular.module('dg.objects')
        .directive('multiPartPropertyValueExtension', multiPartPropertyValueExtension);


}